// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__2pjIh","green":"styles_green__kqORg","blue":"styles_blue__2yASG"};